import Svg, { Path, type PathProps, type SvgProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export interface CardOutlinedIconProps {
  svgProps?: SvgProps
  pathProps?: PathProps
  outlineColor?: string
}

export function CardOutlined({
  svgProps: { width = 24, height = 24, ...svgProps } = {},
  pathProps,
  outlineColor,
}: CardOutlinedIconProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...svgProps}>
      <Path
        d="M4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75V9.25ZM7 6.75H17V5.25H7V6.75ZM19.25 9V15H20.75V9H19.25ZM17 17.25H7V18.75H17V17.25ZM4.75 15V9H3.25V15H4.75ZM7 17.25C5.75736 17.25 4.75 16.2426 4.75 15H3.25C3.25 17.0711 4.92893 18.75 7 18.75V17.25ZM19.25 15C19.25 16.2426 18.2426 17.25 17 17.25V18.75C19.0711 18.75 20.75 17.0711 20.75 15H19.25ZM17 6.75C18.2426 6.75 19.25 7.75736 19.25 9H20.75C20.75 6.92893 19.0711 5.25 17 5.25V6.75ZM7 5.25C4.92893 5.25 3.25 6.92893 3.25 9H4.75C4.75 7.75736 5.75736 6.75 7 6.75V5.25ZM4 10.75H20V9.25H4V10.75ZM15.25 14C15.25 13.8619 15.3619 13.75 15.5 13.75V15.25C16.1904 15.25 16.75 14.6904 16.75 14H15.25ZM15.5 13.75C15.6381 13.75 15.75 13.8619 15.75 14H14.25C14.25 14.6904 14.8096 15.25 15.5 15.25V13.75ZM15.75 14C15.75 14.1381 15.6381 14.25 15.5 14.25V12.75C14.8096 12.75 14.25 13.3096 14.25 14H15.75ZM15.5 14.25C15.3619 14.25 15.25 14.1381 15.25 14H16.75C16.75 13.3096 16.1904 12.75 15.5 12.75V14.25Z"
        fill={outlineColor ?? mesaColorNames['Greyscale/400 #A4AAAC']}
        strokeWidth={0.5}
        {...pathProps}
      />
    </Svg>
  )
}
